// extracted by mini-css-extract-plugin
export default {"grid":"StatTileGrid_grid__y9O-e"};